import api from '../../../api/index';

export default {
    getAllMessages: (data) => api.post('webservice/whatsapp/show-conversation',data),
    postMessages: (data) => api.post('webservice/whatsapp/send-message',data),
}